module.exports = __webpack_public_path__ + "img/header.c543ee1c.png";